import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';

// @react-pdf/renderer v4 dropped its implicit Buffer shim. pdfkit's PNG/font
// embedding (logos + inline question photos) references a global Buffer, which
// Vite does not provide in the browser. Without this the PDF render pipeline
// throws mid-generation and <PDFViewer> retries in a loop → blank/looping
// pdf-preview page. Polyfill it before any PDF code runs.
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}
import './dayjsInit';
import './i18nextInit';
import TagManager from 'react-gtm-module';

if (!import.meta.env.VITE_DISABLE_ANALYTICS) {
  TagManager.initialize({ gtmId: 'GTM-NHQ878G8' });
}

// Catch Vite chunk load failures after deploy; guard prevents infinite reload loop
let preloadReloading = false;
window.addEventListener('vite:preloadError', () => {
  if (preloadReloading) return;
  preloadReloading = true;
  window.location.reload();
});

async function bootstrap() {
  // On native, restore auth from durable native storage BEFORE the store
  // hydrates from localStorage, then kick off native UI init (non-blocking).
  // Wrapped so a native failure can never block rendering the app.
  if (Capacitor.isNativePlatform()) {
    try {
      const { hydrateAuthFromNative } = await import('./utils/nativeStorage');
      await hydrateAuthFromNative();
      import('./native')
        .then(({ initNative }) => initNative())
        .catch((err) => console.error('initNative failed:', err));
    } catch (e) {
      console.error('Native bootstrap failed, continuing:', e);
    }
  }

  // Import App after native hydration so the auth slice reads restored values.
  const { default: App } = await import('./App');
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}

bootstrap();
